var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M4.50006 13.5L10.5001 7.49987L4.50006 1.49988","stroke-linecap":"square"}})
}
var staticRenderFns = []

export { render, staticRenderFns }